const prefix = 'quickUsage';

export const FIND_CURRENT = `${prefix}/FIND_CURRENT`;
